export default "__VITE_ASSET__CyuUJclA__"